import classOperation from '@/api/class-operation'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  ac_status_id: [1, 3],
  editData: [],
  yearList: [],
  termList: [],
  teacherList: [],
  building: [],
  studyTimes: [],
  categories: [],
  classLists: [],
  ac_st_id: [],
  all_year: false,
  history: false,
  branch_id: null,
  acYearFilter: [], // use in table list filter,
  isHasEnrollment: undefined
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.editData = data
  },
  SET_YEAR_LIST(state, data) {
    state.yearList = data
  },
  SET_TERM_LIST(state, data) {
    state.termList = data
  },
  SET_TEACH_LIST(state, data) {
    state.teacherList = data
  },
  SET_BUILDING_LIST(state, data) {
    state.building = data
  },
  SET_STUDY_TIME_LIST(state, data) {
    state.studyTimes = data
  },
  SET_CATEGORY_LIST(state, data) {
    state.categories = data
  },
  SET_CLASS_LIST(state, data) {
    state.classLists = data ? data : []
  },
  SET_ALL_YEAR_FETCH(state, value) {
    state.all_year = value
  },
  SET_STATUS_ID(state, value) {
    state.ac_status_id = value
  },
  SET_AC_ST_ID(state, value) {
    state.ac_st_id = value
  },
  SET_BRANCH_ID(state, data) {
    state.branch_id = data
  },
  SET_ACYEAR_ID_FILTER(state, data) {
    state.acYearFilter = data
  },
  SET_HAS_ENROLMENT_FILTER(state, data) {
    state.isHasEnrollment = data
  }
}

export const actions = {
  async fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        all_branch: Array.isArray(context.state.branch_id)
          ? context.state.branch_id.length
            ? undefined
            : true
          : true,
        filter: {
          ac_status_id: _.join(context.state.ac_status_id, ','),
          ac_st_id: _.join(context.state.ac_st_id, ','),
          ac_year_id: _.join(context.state.acYearFilter, ','),
          has_enrollment: context.state.isHasEnrollment
        }
      },
      attrubutes
    )
    // get all list class
    // await context.dispatch('getListClass')
    return await classOperation.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return classOperation.store(data)
  },

  copyClass(context, data) {
    return classOperation.copyClass(data)
  },

  update(context, { id, data }) {
    return classOperation.update(id, data)
  },
  destroy(context, id) {
    return classOperation.destroy(id)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.editData)) {
      let response = await classOperation.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  async getListClass(context) {
    let response = await classOperation.formViewModel({
      params: {
        fnName: 'class_list'
      }
    })
    context.commit('SET_CLASS_LIST', response.data['class_list'])
  },
  async getAcademicYear(context) {
    let response = await classOperation.formViewModel({
      params: {
        fnName: 'academic_year'
      }
    })

    context.commit('SET_YEAR_LIST', response.data['academic_year'])

    return {
      data: response.data['academic_year']
    }
  },
  async dataBeforeCreate(context) {
    let response = await classOperation.formViewModel({
      params: {
        fnName:
          'study_time,academic_year,academic_term,teacher,building,academic_class_category'
      }
    })

    Object.keys(response.data).forEach(key => {
      if (key == 'academic_year') {
        context.commit('SET_YEAR_LIST', response.data[key])
      }
      if (key == 'academic_term') {
        context.commit('SET_TERM_LIST', response.data[key])
      }
      if (key == 'teacher') {
        context.commit('SET_TEACH_LIST', response.data[key])
      }
      if (key == 'building') {
        context.commit('SET_BUILDING_LIST', response.data[key])
      }
      if (key == 'study_time') {
        context.commit('SET_STUDY_TIME_LIST', response.data[key])
      }
      if (key == 'academic_class_category') {
        context.commit('SET_CATEGORY_LIST', response.data[key])
      }
    })
  },

  async getMainAndSub(context, acps_id) {
    let response = await classOperation.formViewModel({
      params: {
        fnName: 'sub_program_with_main',
        acps_id
      }
    })

    return {
      data: response.data.sub_program_with_main
    }
  },

  async getLevel(context, acps_id) {
    let response = await classOperation.formViewModel({
      params: {
        fnName: 'level_by_sub_program',
        acps_id
      }
    })

    return {
      data: response.data.level_by_sub_program
    }
  },

  async getClassAllowSwap(context, { acps_id, ac_year_id }) {
    let response = await classOperation.formViewModel({
      params: {
        fnName: 'class_allow_swap',
        acps_id,
        ac_year_id
      }
    })

    return {
      data: response.data.class_allow_swap
    }
  },
  async getStudyTime(context) {
    if (!context.state.studyTimes.length > 0) {
      let response = await classOperation.formViewModel({
        params: {
          fnName: 'study_time'
        }
      })
      context.commit('SET_STUDY_TIME_LIST', response.data.study_time)
    }
  },

  formViewModel(context, Options = {}) {
    return classOperation.formViewModel({ params: Options })
  },
}
